module.exports = __webpack_public_path__ + "static/media/quarry.0987cfc3.svg";